(function () {
  'use strict';
  var loader = document.querySelector('script[data-logo-registry]');
  var main = document.querySelector('main');
  if (!loader || !main) return;
  var selectors = 'table th,table td,.fpv-row>span:first-child,.fsc-brand,.fsc-name,.fsp-name,.fpc-nm,.fpc-cmp-name';
  var normalize = function (s) { return s.normalize('NFKC').toLowerCase().replace(/[\s\u200b]+/g, ''); };
  var pending = new WeakSet();
  fetch(loader.dataset.logoRegistry).then(function (response) {
    if (!response.ok) throw new Error('Logo registry unavailable');
    return response.json();
  }).then(function (brands) {
    var aliases = new Map();
    brands.forEach(function (brand) {
      brand.aliases.forEach(function (alias) {
        var key = normalize(alias);
        if (!aliases.has(key)) aliases.set(key, brand);
      });
    });
    var prefixes = Array.from(aliases.keys()).sort(function (a, b) { return b.length - a.length; });
    function replaceText(node, brand) {
      if (pending.has(node) || !node.parentElement || node.parentElement.closest('.fp-comparison-logo,.fp-comparison-logo-text')) return;
      pending.add(node);
      var img = new Image();
      img.alt = brand.name;
      img.width = 112;
      img.height = 48;
      img.decoding = 'async';
      img.onload = function () {
        if (!node.isConnected) return;
        var original = document.createElement('span');
        original.className = 'fp-comparison-logo-text';
        original.textContent = node.textContent;
        original.setAttribute('aria-hidden', 'true');
        var logo = document.createElement('span');
        logo.className = 'fp-comparison-logo' + (brand.dark ? ' is-dark' : '');
        logo.title = brand.name + ' — 出典：' + brand.source;
        logo.dataset.logoSource = brand.source;
        if (brand.crop) {
          var crop = document.createElement('span');
          crop.className = 'fp-comparison-logo__crop';
          crop.style.aspectRatio = brand.crop.width + '/' + brand.crop.height;
          crop.appendChild(img);
          logo.appendChild(crop);
        } else logo.appendChild(img);
        node.replaceWith(logo, original);
        var cell = logo.closest('.fpc-name,.fpc-cmp-name');
        if (cell) {
          var duplicate = cell.querySelector('.fpc-ico');
          if (duplicate) duplicate.hidden = true;
        }
        var card = logo.closest('.fsp-card');
        if (card) {
          var mono = card.querySelector('.fsp-mono');
          if (mono && !mono.querySelector('.fp-comparison-logo')) {
            mono.replaceChildren(logo);
            mono.classList.remove('is-dark', 'is-logo');
            mono.removeAttribute('aria-hidden');
            original.removeAttribute('aria-hidden');
          }
        }
      };
      img.onerror = function () { /* Keep the original label if an asset fails. */ };
      img.src = new URL(brand.asset, loader.src).href;
    }
    function enhance() {
      main.querySelectorAll(selectors).forEach(function (cell) {
        if (cell.closest('nav,header,footer,.fp-comparison-logo,.fp-comparison-logo-text')) return;
        var walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(function (node) {
          if (node.parentElement.closest('script,style,button,select,option,small,.fp-comparison-logo-text')) return;
          var brand = aliases.get(normalize(node.textContent.trim()));
          if (!brand && cell.matches('.fsc-name')) {
            var raw = node.textContent;
            var key = prefixes.find(function (prefix) {
              return normalize(raw).startsWith(prefix) && normalize(raw) !== prefix;
            });
            if (key) {
              var end = 0;
              while (end < raw.length && normalize(raw.slice(0, end)) !== key) end++;
              if (end < raw.length && /店|スタジオ/.test(raw.slice(end))) {
                node.splitText(end);
                brand = aliases.get(key);
              }
            }
          }
          if (brand) replaceText(node, brand);
        });
      });
    }
    enhance();
    var queued = false;
    new MutationObserver(function (records) {
      if (queued || !records.some(function (r) {
        return Array.from(r.addedNodes).some(function (n) {
          return n.nodeType === 1 && !n.matches('.fp-comparison-logo,.fp-comparison-logo-text');
        });
      })) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; enhance(); });
    }).observe(main, { childList: true, subtree: true });
  }).catch(function () { /* Existing labels remain usable when offline. */ });
})();
